































































import { defineComponent, useContext } from '@nuxtjs/composition-api';
import {
ConfigurableProductOptions,
ConfigurableProductOptionsValues,
} from '@vue-storefront/magento-api';
import { useUiState } from '~/composables';

export default defineComponent({
  props: {
    isGood: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: () => {},
    },
    configurableOptions: {
      type: Array,
      default: () => [],
    },
    currentProductVariation: {
      type: Object,
      default: () => {},
    },
    noProductSelected: {
      type: Boolean,
      default: false,
    },
    showMatchingBikes: {
      type: Boolean,
      default: false,
    },
    userFrameSize: {
      type: String,
      default: null,
    },
  },
  emits: ['calculate-frame-size'],
  setup(props) {
    const { app: { i18n } } = useContext();
    const mailTo = `mailto:bernhard@bernhardkohl.at?subject=${i18n.t('Inquiry about')} ${props.product.name}&amp&body=${i18n.t('Please let us know your desired frame size:')}`;
    // eslint-disable-next-line max-len
    const isVariantAvailable = (variant: ConfigurableProductOptionsValues) => props.product.variants?.find((productVariant) => productVariant.attributes[0].label === variant.label && productVariant.product.quantity > 0);

    // Prevents values with '' or "" from not being sorted
    const convertLabelStringToNumber = (value: string) => value.replace(',', '.').replace('"', '').replace(/'/g, '');

    const orderValuesByLabel = (values: ConfigurableProductOptionsValues[]) => {
      const numericValue = convertLabelStringToNumber(values[0].label);

      if (Number.isNaN(Number(numericValue))) return values;

      return values.sort((a, b) => {
        const labelA = Number(convertLabelStringToNumber(a.label));
        const labelB = Number(convertLabelStringToNumber(b.label));
        return labelA - labelB;
      });
    };

    const configurableOptionsTyped: ConfigurableProductOptions[] = (props.configurableOptions as ConfigurableProductOptions[]).map((option) => ({
      ...option,
      values: orderValuesByLabel(option.values),
    }));

    const { toggleFramesizeModal, isFramesizeModalOpen } = useUiState();

    const doToggleFramesizeModal = () => {
      toggleFramesizeModal(
        {
          productSku: props.product.sku,
          productName: props.product.name,
          manufacturerName: props.product.custom?.manufacturer_name,
        },
      );
    };

    return {
      mailTo,
      isVariantAvailable,
      configurableOptionsTyped,
      doToggleFramesizeModal,
      isFramesizeModalOpen,
    };
  },
  watch: {
    isFramesizeModalOpen(newValue: boolean) {
      // recalculate frame size when modal is closed
      if (!newValue) {
        this.$emit('calculate-frame-size');
      }
    },
  },
});
